import { queryOptions, useQuery } from "@tanstack/react-query";
import api from "../../../api";
import type { components } from "../../../types/api.types";
import type { KeysToCamelCase } from "../../../types/caseHelpers.types";
import urls from "../../../urls";

export type RegulatoryDutyType = KeysToCamelCase<
  components["schemas"]["RegulatoryDuty"]
>;

export const regulatoryDutiesQueries = {
  all: () =>
    queryOptions({
      queryKey: ["regulatory-duties"],
      queryFn: fetchRegulatoryDuties,
      staleTime: Infinity
    })
};

function useRegulatoryDuties() {
  return useQuery(regulatoryDutiesQueries.all());
}

async function fetchRegulatoryDuties() {
  const response = await api.get<Array<RegulatoryDutyType>>(
    urls.api.regulatoryDutiesList()
  );
  return response.data;
}

export { useRegulatoryDuties };
